import type { ExploreContentResponsePageAllOfThreeContentItemAuth } from './exploreContentResponsePageAllOfThreeContentItemAuth';
import type { ExploreContentResponsePageAllOfThreeContentItemBasicInfo } from './exploreContentResponsePageAllOfThreeContentItemBasicInfo';
import type { ExploreContentResponsePageAllOfThreeContentItemContent } from './exploreContentResponsePageAllOfThreeContentItemContent';

export type ExploreContentResponsePageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentResponsePageAllOfThreeContentItemAuth;
  basicInfo?: ExploreContentResponsePageAllOfThreeContentItemBasicInfo;
  /** 콘텐츠 데이터 (타입에 따라 다른 형식) */
  content?: ExploreContentResponsePageAllOfThreeContentItemContent;
};
